import React, { FC } from 'react';

import { MultilineTextCellFormatter } from '@evinced-private/ui-common';

import { NumberedBadge } from 'src/common/components/numbered-badge/NumberedBadge';

import './IssueElementInfoFormatter.scss';

export interface IElementInfo {
	value: string;
	displayName: string;
}

interface IIssueElementInfoFormatterProps {
	elementInfo: IElementInfo[];
	nodeNumber: string;
	withTooltip?: boolean;
}

export const IssueElementInfoFormatter: FC<IIssueElementInfoFormatterProps> = ({
	elementInfo,
	nodeNumber,
	withTooltip
}) => {
	return (
		<div className="issue-element-info-formatter">
			<NumberedBadge number={nodeNumber} />
			<div className="element-details">
				{elementInfo?.map(({ displayName, value }, index) => (
					<div
						key={displayName}
						className={`element-detail ${index === elementInfo.length - 1 ? 'last' : ''}`}
					>
						<span className="element-label">{displayName}: </span>
						{withTooltip ? (
							<div className="element-value">
								<MultilineTextCellFormatter
									items={[value]}
									itemType="text"
									showTooltip={value.length > 15}
								/>
							</div>
						) : (
							value
						)}
					</div>
				))}
			</div>
		</div>
	);
};
